import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('ui-addon-i18n', {
  library: 'ui-addon-i18n'
});